export const getModifiedScripts = (scripts: string): string => {
	// we have to remove these statements from inDesign generated script for enabling text selection in buttons
	const textToReplace = 'event\\.stopPropagation\\(\\);|event\\.preventDefault\\(\\);';
	const regExp = new RegExp(textToReplace, 'g');

	return scripts.replace(regExp, '');
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/scripts.ts